<template>
  <div class="flex gap-1">
    <div class="col">
      <label>MODELO</label>
      <v-select id="modelo" :options="modelos" v-model="modelo"></v-select>
    </div>
    <div class="col">
      <label>FORMATO</label>
      <v-select :options="formatos" v-model="formato"></v-select>
    </div>
    <div class="col">
      <label>LADRILHO</label>
      <v-select  :options="ladrilhos" v-model="ladrilho" label="label">
        <template #option="{ name, svg, floral, svgFloral, label}">
          <div class="flex align-center filter gap18" v-if="!floral">
            <img v-if="!checkLocalStorage(svg)" :src="urlSvg + svg" class="svg">
            <div v-else v-html="checkLocalStorage(svg)" class="svg" style="min-width: 80px">
            </div>
            <h3 style="margin: 0">{{ label }}</h3>
          </div>

          <div class="flex align-center gap18" v-if="floral">
            <div class="flex" style="min-width: 120px">
              <img :src="urlSvg + svgFloral" class="svg" style="max-width: 60px" v-if="!checkLocalStorage(svgFloral)">
              <div v-else v-html="checkLocalStorage(svgFloral)" class="svgFl" ></div>

              <img v-if="!checkLocalStorage(svg)" :src="urlSvg + svg" class="svg" style="max-width: 60px">
              <div v-else v-html="checkLocalStorage(svg)" class="svgFl"></div>
            </div>
            <h3 style="margin: 0">{{ label }}</h3>
          </div>
        </template>
      </v-select>
    </div>
  </div>
</template>

<script>
import { default as list } from '../assets/list.json';


export default {
  name: "Filter",
  data() {
    return {
      list : list,
      modelos : [],
      formatos : [],
      ladrilhos : [],
      modelo: '',
      formato: '',
      ladrilho: '',
      urlSvg: process.env.VUE_APP_SVG,
    }
  },
  props: [],
  mounted() {
    this.getModelo()
  },
  watch: {
    modelo() {
      this.getFormatos();
    },
    formato() {
      this.getLadrilhos();
    },
    ladrilho() {
      this.$emit('changeLadrilho', this.ladrilho)
    }
  },
  methods: {
    getModelo() {
      this.list.data.forEach((x) => {
        if(!this.modelos.includes(x.MODELO)) {
          this.modelos.push(x.MODELO)
        }
      });
    },
    checkLocalStorage(svg) {
      let item = localStorage.getItem(svg);
      return item != undefined ? item : '';
    },
    getFormatos() {
      this.formatos = [];
      this.formato = '';
      let formatos = this.list.data.filter((x) => x.MODELO == this.modelo);
      formatos.forEach((x) => {
        if(!this.formatos.includes(x.FORMATO.toUpperCase())) {
          this.formatos.push(x.FORMATO.toUpperCase())
        }
      })
    },
    getLadrilhos() {
      this.ladrilhos = [];
      this.ladrilho = '';
      let ladrilhos = [];
      ladrilhos = this.list.data.filter((x) => x.MODELO == this.modelo && x.FORMATO.toUpperCase() == this.formato && !x.SVG.includes('A_'));
      ladrilhos = ladrilhos.sort((a, b)  => {
        return a['LABEL'].localeCompare(b['LABEL'], undefined, { numeric: true, sensitivity: 'base' });
      });
      ladrilhos.forEach((x) => {
        if(!this.ladrilhos.includes(x.SVG.toUpperCase())) {
          let floral = this.list.data.findIndex((y) => y.SVG.includes(x.SVG.split('_')[1] + 'A_'));

          this.ladrilhos.push({
            "name" : x.SVG.toUpperCase().split('_')[0],
            "label" : x.hasOwnProperty('LABEL') ? x.LABEL.toUpperCase() : x.SVG.toUpperCase().split('_')[0],
            "svg" : x.SVG.toUpperCase() + '.svg',
            "floral" : floral != -1 ? true : false,
            "horizontal": x.FORMATO.toUpperCase() == "10X20",
            "modulado": x.TIPO.includes("MODULADO"),
            "hexagonal": x.TIPO.includes("HEX"),
            "tamanho": x.FORMATO.toUpperCase(),
            "modelo": x.MODELO,
            "svgFloral" : floral != -1 ? this.list.data[floral].SVG + '.svg' : '',
          })
        }
      })
    }
  }
}
</script>

<style scoped>
.flex v-select {
  width: 100%;
}

label {
  font-weight: 600;
}
.gap18 {
  gap: 18px;
}
.svg {
  max-width: 80px;
  height: auto;
}

.svg, .svg svg {
  max-width: 80px;
  height: auto;
}
</style>

<style>
.filter svg {
  width: 80px;
  height: auto;
}

.svgFl {
  min-width: 60px;
}

.svgFl svg {
  width: 60px;
  height: auto;
}

.filter svg .st0 {
  display: block !important;
}
</style>